// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qov3","colBig":"styles_colBig__2P3m3","colSmall":"styles_colSmall__344IY"};